import { HashLink } from 'react-router-hash-link';

function DocsNav({ chapters, sectionId, basePath }) {
  return (
    <div className="pt-3">
      <strong className="mb-2 d-block small fw-bold text-uppercase text-secondary">
        On this page
      </strong>
      <ul className="list-unstyled">
        {chapters.map(ch => (
          <li key={ch.id}>
            <HashLink
              smooth
              to={`${basePath}/${sectionId}#${ch.id}`}
              className="text-decoration-none d-block py-1 text-muted small nav-chapter-link"
            >
              {ch.title}
            </HashLink>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DocsNav;
